export const model = {
  driveTrainType: "工作等级",
  driveTrainTypeCombustion: "燃油",
  driveTrainTypeEV: "电池",
  inspectionTemplate: "点检模板",
  make: "品牌",
  modelName: "型号",
  tireDimension: "轮径（{0}）",
  tireDimensionNoUnit: "轮径",
  vehicles: "设备总数",
};
